import styled from "styled-components";
import {media} from "../../../theme/responsive";

export const VisionStatementWrapper = styled.div`
    padding-top: 20px;
    padding-bottom: 20px;
    ${media.laptop`padding-top: 60px; padding-bottom: 100px;`}
`;

export const VisionContentDiv = styled.div`
    font-size: 0.875rem;
    ul {
        margin-top: 20px;
    }
    a {
        display: unset;
    }
`;
